import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { SidePanelVariant, SidePanel } from '@cbridge-modules/layout';
import { streamDetailsSidebarPropsSelector } from './StreamDetailsSidebar.selector';
import { StreamDetails } from './content/StreamDetails';

export const StreamDetailsSidebar: FunctionComponent = () => {
  const { isShown } = useSelector(streamDetailsSidebarPropsSelector);

  if (!isShown) {
    return null;
  }

  return (
    <SidePanel variant={SidePanelVariant.Right}>
      <StreamDetails />
    </SidePanel>
  );
};
